import script from "./VAppSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAppSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./VAppSidebar.vue?vue&type=style&index=0&id=4b9200b1&lang=scss"

const __exports__ = script;

export default __exports__